$(document).ready(function(){
  $(".product-form .opt-btn").on("change", function(){
    setTimeout(function() {
      var price = $(this).closest(".product-detail").find(".current-price.theme-money").text();
      console.log(price)
     $(".quantity-submit-row__submit .variant-price").html(price);
    }.bind(this), 200);
  });

$(".custom_cart_items").click(function() {
  $(".product-purchase-form button").trigger("click");

});

// // Create the SVG element
// var svg = '<span class="appended_Svg_js"><svg width="24px" height="24px" viewBox="0 0 24 24" aria-hidden="true">' +
//     '<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
//     '<path d="M3.5,2.75 C4.87766445,2.75 5.56649668,2.75 5.56649668,2.75 C5.56649668,2.75 6.03257795,7.25 6.96474049,16.25 L19.5,16.25" stroke="currentColor" stroke-linecap="square"></path>' +
//     '<path d="M6.22627526,6.67553191 C14.8659742,6.67553191 19.1858237,6.67553191 19.1858237,6.67553191 C19.1858237,6.67553191 18.9160351,8.71453901 18.376458,12.7925532 L7.62925996,13.9095745" stroke="currentColor" stroke-linecap="square"></path>' +
//     '<circle stroke="currentColor" cx="8.875" cy="20.005" r="1.375"></circle>' +
//     '<circle stroke="currentColor" cx="17.375" cy="20.005" r="1.375"></circle>' +
//     '</g>' +
//     '</svg></span>';

// // Insert the SVG before the element with class 'items_Custom_added'
// $(svg).insertBefore(".quantity-submit-row__submit .items_Custom_added");



// var originalPrice = parseFloat($(".quantity-submit-row__submit .variant-price").text().replace(/\$|,/g, ''));

// $(".up_qty").on("click", function(event){
//   event.preventDefault(); 

//   var currentPrice = parseFloat($(".quantity-submit-row__submit .variant-price").text().replace(/\$|,/g, ''));

//   var updatedPrice = currentPrice * 2;

//   var formattedPrice = updatedPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

//   $(".quantity-submit-row__submit .variant-price").text(formattedPrice);
// });

// $(".down_qty").on("click", function(event){
//   event.preventDefault(); 

//   var currentPrice = parseFloat($(".quantity-submit-row__submit .variant-price").text().replace(/\$|,/g, ''));

//   var updatedPrice = Math.max(currentPrice / 2, originalPrice);

//   var formattedPrice = updatedPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

//   $(".quantity-submit-row__submit .variant-price").text(formattedPrice);
// });



  $('.template-product .product-img--main')
        // tile mouse actions
        .on('mouseover', function(){
          $(this).children('.product-img--main__image').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
        })
        .on('mouseout', function(){
          $(this).children('.product-img--main__image').css({'transform': 'scale(1)'});
        })
        .on('mousemove', function(e){
          $(this).children('.product-img--main__image').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
        })
        // tiles set up
        .each(function(){
          $(this)
            // add a image container
            .append('<div class="product-img--main__image"></div>')
            // set up a background image for each tile based on data-image attribute
            .children('.product-img--main__image').css({'background-image': 'url('+ $(this).attr('data-image') +')'});
        });

});

